<script lang="ts">
import { setLabelledByAttribute } from '@/utils/utils'
import { kebabCase } from 'change-case'
import { defineComponent } from 'vue'

/**
 * A container to display a section.
 */
export default defineComponent({
  props: {
    /**
     * Sets the minimum height of the section. Default is 712px.
     */
    minHeight: {
      type: [String, Number],
      default: '90vh',
    },
  },
  mounted() {
    setLabelledByAttribute(this.$el)
  },
})
</script>

<template>
  <section
    class="relative mx-auto flex w-full max-w-screen-xl flex-col gap-y-3 px-3 py-5 @md/main:px-8"
  >
    <slot />
  </section>
</template>

<style lang="scss"></style>
